import React from 'react';
import { useNavigate } from 'react-router-dom';

const VerifyYourAccount = () => {
    const navigate = useNavigate();
    const onSubmit = (e) => {
        e.preventDefault();
        navigate("/otp_verification");
    }
  return (
    <>
    <div className='verify_account'>
        <div className='col-md-4 mx-auto bg-light'>
            <div className='shadow p-4'>
                <div>Enter your registered email ID to verify your account</div>
                <form className='w-75 mx-auto'>
                    <div className=' form-group my-3'>
                        <input type='email' className='custom-input' placeholder='example@user.com' />
                    </div>
                    <div className='mt-2'>
                        <button type='button' onClick={onSubmit} className=' btn btn-primary btn-signup btn-lg'>Submit</button>
                    </div>
                    
                    
                </form>
            </div>
        </div>
    </div>
     
    </>
  );
}

export default VerifyYourAccount;
